import {emptyValue} from "./global";

function getYesOrNoDisplay(value){
    if(value === 'NO') return 'Nein';
    else if(value === 'YES') return 'Ja';
    else return emptyValue;
}

export default getYesOrNoDisplay;